module.exports = __webpack_public_path__ + "@/assets/img/welcome-banner.300d5200.png";